<template>
  <base-material-card
      v-if="currentChat"
  >
    <template v-slot:heading>
      <div class="subtitle-1 font-weight-light d-flex">
        <div>{{ currentChat.title }}</div>
        <v-spacer/>
        <chat-search :search-select-message-fnc="chatSearch"/>
        <v-btn icon small @click="chatInfoPanelShow = true">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </div>
    </template>
    <template v-slot:heading_action>

    </template>

    <v-list
        class="overflow-y-auto pl-1 pr-1"
        :max-height="chatHeight"
    >
      <v-list-item>
        <v-btn
            small
            @click="getPrevHistoryComments"
            :disabled="!canLoadCommentHistory"
        >
          Еще
        </v-btn>
      </v-list-item>

      <v-list-item
          v-for="messageItem in currentChatMessages"
          :key="messageItem.id"
          class="chat"
      >
        <v-list-item-content
            :class="['pb-0 align-self-start', messageItem.username === currentUser ? 'text-right ml-15' : 'text-left mr-15']"
        >
          <chat-message
              :scroll-to-quoted-message-fnc="scrollToQuotedMessage"
              :set-quoted-message-fnc="setQuotedMessage"
              :create-service-fnc="createService"
              :message="messageItem"
          ></chat-message>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-btn
            small
            @click="getNextHistoryComments"
            v-if="isSearch"
        >
          Еще
        </v-btn>
      </v-list-item>
      <chat-info-panel v-model="chatInfoPanelShow"></chat-info-panel>
    </v-list>
    <template v-slot:actions v-if="canWrite" class="pa-0">
      <template v-if="chatForwardMode">
        <v-btn
            icon
            v-on:click="clearForwardMessage"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <span>Выбранно: {{ chatForwardMessageList.length }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="showForwardDialog" :disabled="chatForwardMessageList.length === 0">
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </template>
      <template v-else-if="chatCreateServiceMode">
        <v-btn
            icon
            v-on:click="clearCreateServiceMessage"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <span>Выбранно: {{ chatCreateServiceMessageList.length }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="showCreateServiceDialog" :disabled="chatCreateServiceMessageList.length === 0">
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-col class="pa-0">
          <v-card class="pa-0" flat>
            <v-card-text
                class="pa-0 quotedComment"
                v-if="quotedComment">
              <v-list-item two-line>
                <v-list-item-content>
                  <chat-message
                      :message="quotedComment"
                      :is-quoted="true"
                  ></chat-message>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon
                      color="grey lighten-1"
                      @click="closeQuotedComment"
                  >
                    mdi-close
                  </v-icon>
                </v-list-item-action>
              </v-list-item>

            </v-card-text>
            <v-card-text class="pa-0" v-if="canWrite">
              <v-text-field
                  v-model="newMessage.text"
                  hide-details
                  placeholder="Новое сообщение"
                  v-on:keyup.enter="sendNewMessage"
                  ref="messageInput"
              >
                <template slot="prepend" v-if="canCreateService">
                  <v-menu
                      top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                      >
                        mdi-face-agent
                      </v-icon>
                    </template>
                    <v-list>
                      <v-list-item @click="createService">
                        <v-list-item-title>
                          <v-icon>
                            mdi-credit-card-plus-outline
                          </v-icon>
                          Создать заявку
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="sendMessageToServiceModal">
                        <v-list-item-title>
                          <v-icon>
                            mdi-message-plus-outline
                          </v-icon>
                          Отправить сообщения в заявку
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <template slot="append">
                  <v-menu
                      top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          class="mr-5"
                          v-bind="attrs"
                          v-on="on"
                      >mdi-at
                      </v-icon>
                    </template>
                    <v-list>
                      <v-list-item
                          v-for="(attendee, index) in currentChat.attendees.filter(a => a.isAutoAdded === false)"
                          :key="'at_attend_'+index"
                          @click="tagToMessage(attendee)"
                      >
                        <v-list-item-title>
                          {{ attendee.displayName }}
                        </v-list-item-title>

                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu
                      top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                      >mdi-paperclip
                      </v-icon>
                    </template>
                    <v-list>
                      <v-list-item @click="showDocumentMessageDialog(2)">
                        <v-list-item-title>
                          <v-icon>
                            mdi-message-image-outline
                          </v-icon>
                          Добавить картинку
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="showDocumentMessageDialog(4)">
                        <v-list-item-title>
                          <v-icon>
                            mdi-text-box-plus-outline
                          </v-icon>
                          Добавить документ
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <template slot="append-outer">
                  <v-btn
                      text
                      color="blue darken-1"
                      @click="sendNewMessage"
                      :loading="axiosLoading"
                  >
                    <v-icon>mdi-send</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-card-text>
          </v-card>
        </v-col>
      </template>
    </template>
    <v-dialog
        v-model="forward.dialog"
        width="500"
    >
      <v-card>
        <v-card-title>
          Переслать сообщение
        </v-card-title>

        <v-card-text>
          <v-list
              class="overflow-y-auto"
              max-height="calc(95vh - 210px)"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <v-text-field
                      v-model="forward.searchValue"
                      denses
                      placeholder="Поиск"
                  >
                    <v-icon
                        slot="append"
                    >
                      mdi-magnify-scan
                    </v-icon>
                  </v-text-field>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-virtual-scroll
                item-height="50"
                :items="chatDictionaryList"
                height="calc(100vh - 400px)"
            >
              <template v-slot:default="{ item }">
                <v-list-item :key="item.id">
                  <v-list-item-action>
                    <v-checkbox v-model="forward.activityIdList"
                                :value="item.id"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title v-html="item.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-btn
              color="primary"
              text
              @click="forward.dialog = false"
          >
            {{ this.$vuetify.lang.t('$vuetify.page.action.btnCancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="sendForwardMessage"
          >
            {{ this.$vuetify.lang.t('$vuetify.page.action.btnSend') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="documentMessage.dialog"
        width="500"
    >
      <v-card>
        <v-card-title>
          Прикрепить {{ documentMessage.documentType === 2 ? 'изображение' : 'документ' }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <!--                        <v-col-->
            <!--                            cols="12">-->
            <!--                            <v-text-field-->
            <!--                                    label="Название"-->
            <!--                                    v-model="documentMessage.caption"-->
            <!--                                    dense-->
            <!--                                    outlined-->
            <!--                                    hide-details="auto"-->
            <!--                                    :rules="[fieldValidationRules.required(vue)]"-->
            <!--                            ></v-text-field>-->
            <!--                        </v-col>-->
            <!--                        <v-col-->
            <!--                            cols="12">-->
            <!--                            <v-file-input-->
            <!--                                    label="Файл"-->
            <!--                                    v-model="documentMessage.file"-->
            <!--                                    :accept="documentMessage.documentType === 2 ? 'image/*' : '*'"-->
            <!--                                    multiple-->
            <!--                                    dense-->
            <!--                                    outlined-->
            <!--                                    hide-details="auto"-->
            <!--                                    :rules="[fieldValidationRules.required(vue)]"-->
            <!--                            ></v-file-input>-->
            <!--                        </v-col>-->
            <v-col
                cols="12">
              <div class="pa-4 grey" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                <input
                    type="file"
                    multiple
                    name="fields"
                    id="assetsFieldHandle"
                    class="hideFileSelect"
                    @change="onChange"
                    ref="file"
                    :accept="documentMessage.documentType === 2 ? 'image/*' : '*'"
                />
                <label for="assetsFieldHandle" class="block cursor-pointer">
                  <div>
                    Переместите файл(ы) или нажмите для загрузки
                  </div>
                </label>
                <ul class="mt-4" v-if="documentMessage.file.length" v-cloak>
                  <li class="text-sm p-1" v-for="(file, index) in documentMessage.file" :key="index">
                    {{ file.name }}
                    <button class="ml-2 red--text" type="button" @click="remove(documentMessage.file.indexOf(file))"
                            title="Удалить файл">удалить
                    </button>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
              color="primary"
              text
              @click="documentMessage.dialog = false"
          >
            {{ this.$vuetify.lang.t('$vuetify.page.action.btnCancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="sendDocumentMessage"
          >
            {{ this.$vuetify.lang.t('$vuetify.page.action.btnSend') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialog.createService"
        transition="dialog-bottom-transition"
        max-width="700"
    >
      <v-card>
        <v-card-text class="pa-0">
          <service-card
              service-id="00000000-0000-0000-0000-000000000000"
              :only-create="true"
          ></service-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialog.sendToService"
        transition="dialog-bottom-transition"
        max-width="500"
    >
      <v-card>
        <v-card-text class="pa-0">
          <v-list
            dense
          >
            <v-list-item
              v-for="servicesInWork in chatServicesInWorkList"
              :key="'servicesInWork_' + servicesInWork.id"
              @click="sendMessageToService(servicesInWork.id)"
            >
              <v-list-item-content>
                <v-list-item-title v-html="serviceInWorkTitle(servicesInWork)"></v-list-item-title>
                <v-list-item-subtitle v-html="serviceInWorkSubTitle(servicesInWork)"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </base-material-card>
</template>

<script>
import {ChatCategory} from "@/enums/chatCategory";

export default {
  name: "ChatPanel",
  components: {
    ChatSearch: () => import('./ChatSearch'),
    ChatMessage: () => import('./ChatMessage'),
    ChatInfoPanel: () => import('./ChatInfoPanel'),
  },
  created() {
    window.VueEvent.listen('clear-create-service-message', this.clearCreateServiceMessage);
  },
  computed: {
    currentChat() {
      return this.$store.getters.currentChat
    },
    currentChatMessages() {
      return this.$store.getters.currentChatMessages
    },
    currentUser() {
      return this.$store.getters.user
    },
    canLoadCommentHistory() {
      return this.currentChat.commentCount > this.currentChatMessages.length
    },
    chatDictionaryList() {
      let sv = ''
      if (this.forward.searchValue) {
        sv = this.forward.searchValue.toLowerCase()
      }
      return this.forward.searchValue ?
          this.$store.getters.chatDictionaryList.filter(item => item.name.toLowerCase().includes(sv)) :
          this.$store.getters.chatDictionaryList
    },
    canWrite() {
      if (this.$store.getters.hasRole(['Administrator', 'ClientManager'])) {
        return true
      }
      return this.currentChat.attendees.some(item => item.username === this.$store.getters.user && item.isAutoAdded === false)
    },
    chatHeight() {
      let actionHeight = this.canWrite ? '0px' : '100px'
      return `calc(100vh - 250px + ${actionHeight})`
    },
    chatForwardMode() {
      return this.$store.getters.chatForwardMode
    },
    chatForwardMessageList() {
      return this.$store.getters.chatForwardMessageList
    },
    chatCreateServiceMode() {
      return this.$store.getters.chatCreateServiceMode
    },
    chatCreateServiceMessageList() {
      return this.$store.getters.chatCreateServiceMessageList
    },
    canCreateService(){
      return this.currentChat.category === ChatCategory.EXTERNAL_CHAT || this.currentChat.category === ChatCategory.CLIENT_TICKETS
    }
  },
  watch: {
    // currentChatMessages: function () {
    //     if (!this.getHistoryComments) {
    //         this.scrollToMessage()
    //     }
    // }
    // chatForwardMode: function () {
    //   if (!this.chatForwardMode) {
    //     this.clearForwardMessage()
    //   }
    // }
  },
  updated: function () {
    this.$nextTick(function () {
      this.scrollToMessage()
    })
  },
  data() {
    return {
      vue: this,
      currentChatId: null,
      newMessage: {
        text: '',
        tagAttendee: null,
        quotedCommentId: null
      },
      quotedComment: null,
      chatInfoPanelShow: false,
      getHistoryComments: null,
      isSearch: false,
      multimedia: {
        dialog: false,
        message: null,
      },
      forward: {
        messageList: [],
        activityIdList: [],
        dialog: false,
        searchValue: null
      },
      documentMessage: {
        dialog: false,
        documentType: null,
        caption: null,
        file: []
      },
      dialog: {
        createService: false,
        sendToService: false
      },
      isSendMessageToService: false,
      chatServicesInWorkList: []
    }
  },
  methods: {
    sendNewMessage() {
      if (this.newMessage.text) {
        let mentionedPhones = []
        let messageText = this.newMessage.text
        this.newMessage.tagAttendee?.forEach(attendee => {
          if (messageText.indexOf(`@${attendee.displayName}`) > -1) {
            messageText = messageText.replace(`@${attendee.displayName}`, `@${attendee.phone}`)
            mentionedPhones.push(`${attendee.phone}`)
          }
        })

        this.$store.dispatch('sendMessage', {
          text: messageText,
          mentionedPhones: mentionedPhones.length > 0 ? mentionedPhones : null,
          quotedCommentId: this.newMessage.quotedCommentId
        })
            .then(() => {
              this.newMessage = {
                text: '',
                tagAttendee: null,
                quotedCommentId: null
              }
              this.quotedComment = null
            })
      }
    },
    chatSearch(selectedMessage) {
      this.isSearch = true
      this.$store.dispatch('retrieveSearchChat', {
        chatId: this.currentChat.id,
        messageId: selectedMessage.id,
        limit: 10,
        loadBefore: true,
        isForward: false
      }).then(() => {
        this.scrollToMessage(selectedMessage.id)
      })
    },
    scrollToMessage(messageId) {
      this.$nextTick().then(() => {
        if (this.$refs.messageInput) {
          this.$refs.messageInput.$refs.input.focus()
        }

        let new_message = messageId ? document.getElementById(messageId) : document.getElementsByClassName('new_message')[0];
        if (new_message) {
          this._scrollToNewMessage(new_message, true)
        } else {
          let messages = document.getElementsByClassName('chat v-list-item');
          if (messages.length > 0) {
            let target = messages[messages.length - 1]
            this._scrollToNewMessage(target, true)
          } else {
            // this.$nextTick().then(() => {
            //     this.scrollToMessage()
            // })
          }
        }

      });
    },
    _scrollToNewMessage(target, alignToTop) {
      if (target) {
        target.scrollIntoView(alignToTop);
      }
    },
    _getMoreHistoryComments(messageId, isForward = false, isScrollToMessage = true) {
      return new Promise((resolve) => {
        this.$store.dispatch('retrieveChatCommentHistory', {
          chatId: this.currentChat.id,
          messageId: messageId,
          limit: 20,
          isForward: isForward
        }).then(() => {
          if (!isForward && isScrollToMessage) {
            let target = document.getElementById(this.getHistoryComments);
            this._scrollToNewMessage(target, true)
          }
          this.getHistoryComments = null
          resolve()
        })
      })
    },
    getPrevHistoryComments() {
      this.getHistoryComments = this.currentChatMessages[0].id
      this._getMoreHistoryComments(this.getHistoryComments)
    },
    getNextHistoryComments() {
      this.getHistoryComments = this.currentChatMessages[this.currentChatMessages.length - 1].id
      this._getMoreHistoryComments(this.getHistoryComments, true)
    },
    newLineMessage(e) {
      let caret = e.target.selectionStart;
      e.target.setRangeText("\n", caret, caret, "end");
      this.newMessage = e.target.value;
    },
    scrollToQuotedMessage(messageId) {
      this._scrollToQuotedMessage(messageId).then(() => {
        let elm = document.getElementById(messageId)
        elm.classList.add("highlight");

        setTimeout(function () {
          let elm = document.getElementById(messageId)
          elm.classList.remove("highlight");
        }, 3000);
      })
    },
    setQuotedMessage(messageId) {
      this.newMessage.quotedCommentId = messageId
      this.quotedComment = this.currentChatMessages.find(m => m.id === messageId)
      this.$nextTick().then(() => {
        if (this.$refs.messageInput) {
          this.$refs.messageInput.$refs.input.focus()
        }
      })
    },
    _scrollToQuotedMessage(messageId) {
      return new Promise((resolve) => {
        let new_message = document.getElementById(messageId);
        if (new_message) {
          this.scrollToMessage(messageId)
        } else {
          let firstComment = this.currentChatMessages[0].id
          this._getMoreHistoryComments(firstComment, false, false).then(() =>
              this._scrollToQuotedComment(messageId)
          )
        }

        resolve()
      })
    },
    clearForwardMessage() {
      this.$store.dispatch('clearChatForward')
      this.forward.activityIdList = []
      this.forward.dialog = false
      this.forward.searchValue = null
      window.VueEvent.fire('clear-all-chat-forward')
    },
    showForwardDialog() {
      this.$store.dispatch('retrieveChatDictionaryList').then(() => {
        this.$nextTick(() => {
          this.forward.dialog = true
        })
      })
    },
    sendForwardMessage() {
      this.$store.dispatch('forwardMessage', {
        forwardToChatList: this.forward.activityIdList,
        messageForwardList: this.chatForwardMessageList
      }).then(() => this.clearForwardMessage())
    },
    showDocumentMessageDialog(messageType) {
      this.documentMessage.documentType = messageType
      this.documentMessage.caption = '-'
      this.documentMessage.file = []
      this.documentMessage.dialog = true
    },
    sendDocumentMessage() {
      if (this.documentMessage.file) {
        this.$store.dispatch('sendDocumentMessage', this.documentMessage)
            .then(() => {
              this.documentMessage.dialog = false
              this.documentMessage.documentType = null
              this.documentMessage.caption = '-'
              this.documentMessage.file = []
            })
      }
    },
    onChange() {
      this.documentMessage.file = [...this.$refs.file.files];
    },
    remove(i) {
      this.documentMessage.file.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('lighten-3')) {
        event.currentTarget.classList.remove('lighten-3');
        event.currentTarget.classList.add('lighten-1');
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add('lighten-3');
      event.currentTarget.classList.remove('lighten-1');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // // Clean up
      event.currentTarget.classList.add('lighten-3');
      event.currentTarget.classList.remove('lighten-1');
    },
    tagToMessage(attendee) {
      const atMessage = (this.newMessage.text.length > 0 ? ' ' : '') + `@${attendee.displayName} `
      const messageInput = this.$refs.messageInput.$refs.input
      const sentence = messageInput.value
      const len = sentence.length
      let pos = messageInput.selectionStart
      if (pos === undefined) {
        pos = 0
      }

      const before = sentence.substr(0, pos)
      const after = sentence.substr(pos, len)

      this.newMessage.text = before + atMessage + after

      this.$nextTick().then(() => {
        messageInput.selectionStart = pos + atMessage.length
      })

      if (!this.newMessage.tagAttendee) {
        this.newMessage.tagAttendee = []
      }

      this.newMessage.tagAttendee.push(attendee)
    },
    closeQuotedComment() {
      this.quotedComment = null
    },
    createService() {
      this.isSendMessageToService = false
      this.$store.dispatch('setChatCreateServiceMode', true)

    },
    sendMessageToServiceModal() {
      this.$store.dispatch('getChatServicesInWorkList', true).then((response) => {
        this.chatServicesInWorkList = response
        this.isSendMessageToService = true
        this.$store.dispatch('setChatCreateServiceMode', true)
      })
    },
    sendMessageToService(serviceId){
      this.$store.dispatch('sendCommentToService', {serviceId: serviceId, commentToWorkIds: this.chatCreateServiceMessageList}).then(() => {
        this.dialog.sendToService = false
        this.$store.dispatch('clearChatCreateService')
        window.VueEvent.fire('clear-all-chat-create-service')
      })
    },
    clearCreateServiceMessage() {
      this.dialog.createService = false
      this.dialog.sendToService = false
      this.$store.dispatch('clearChatCreateService')
      window.VueEvent.fire('clear-all-chat-create-service')
    },
    showCreateServiceDialog() {
      if(!this.isSendMessageToService) {
        this.dialog.createService = true
      } else {
        this.dialog.sendToService = true
      }
    },
    serviceInWorkTitle(service) {
      return `Заявка №${service.number} Клиент ${service.client.name}`
    },
    serviceInWorkSubTitle(service) {
      return `Статус ${service.serviceStatus.name}`
    },
  },
}
</script>

<style scoped lang="scss">
.hideFileSelect {
  width: 1px;
  height: 1px;
  overflow: hidden;
  position: absolute;
}

.quotedComment {
  border-left: #1E88E5 3px solid;
  background-color: #B3E5FC;
  border-radius: 10px !important;
}
</style>